module.exports = __webpack_public_path__ + "static/1.2.C.3 Randare 4-37d9aa11329673697378c8e75fb5c3ee.jpg";